import React, { FC } from 'react';

import EmptyStatePrompt from '@components/common/EmptyStatePrompt';
import ColorWrapper, { WithColor } from '@styles/colors';
import { SimpleOnPress } from '@interfaces/base';

interface RefreshProps extends WithColor, SimpleOnPress {
  background?: string;
  text?: string;
}

const Refresh: FC<RefreshProps> = ({ onPress, background, C, text = 'Something went wrong' }) => (
  <EmptyStatePrompt onPress={onPress} background={background} C={C} text={text} buttonText="Retry" />
);

export default ColorWrapper(Refresh);
